import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ContactForm from '../components/ContactForm';
import Seo from '../components/Seo';

const address = '5150 Linton Blvd, Suite 250, Delray Beach, FL 33484';
const phone = '(561) 638-7577';
const fax = '(561) 638-9322';
const hours = 'Monday–Friday, 8 AM–5 PM';
const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

function CopyRow({ label, value, href }) {
  return (
    <div className="contact-row">
      <p className="contact-row-label">{label}</p>
      <div className="contact-row-value">
        {href ? (
          <a href={href}>{value}</a>
        ) : (
          <span>{value}</span>
        )}
      </div>
    </div>
  );
}

const ContactPage = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const isNewPractice = type === 'new-practice';

  return (
    <div className="contact-page">
      <Seo
        title="Contact Our Florida Pathology Laboratory"
        path="/contact"
        description="Contact Boca-Delray Pathology Laboratories in Delray Beach, FL: phone, fax, address, and a secure form for practice questions and referring-practice setup."
      />
      <section className="page-banner">
        <p className="section-label">{isNewPractice ? 'New Referring Practice' : 'Get In Touch'}</p>
        <h1>{isNewPractice ? 'Become a Referring Practice' : 'Contact Us'}</h1>
        <p>
          {isNewPractice
            ? "Tell us about your practice and we'll set up courier pickup, provider portal access, and billing details."
            : "Get in touch with our team of expert pathologists. We're here to assist you with any questions or inquiries about our anatomic pathology services."}
        </p>
      </section>

      <div className="contact-layout">
        <aside className="contact-card">
          <h2>Lab details</h2>
          <CopyRow label="Phone" value={phone} href="tel:+15616387577" />
          <CopyRow label="Fax" value={fax} />
          <CopyRow label="Address" value={address} href={mapUrl} />
          <CopyRow label="Hours" value={hours} />
          <a className="map-link" href={mapUrl} target="_blank" rel="noopener noreferrer">
            Open in Google Maps
          </a>
        </aside>

        <section className="contact-form-section">
          <h2>Send Us a Message</h2>
          <p className="form-intro">For credentialing, courier setup, or other practice inquiries. Patient results are not released through this form.</p>
          <ContactForm defaultInquiryType={isNewPractice ? 'new-practice' : 'general'} />
        </section>
      </div>
    </div>
  );
};

export default ContactPage;
